var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography as AntTypography } from "antd";
var Typography = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntTypography, __assign({}, props));
};
Typography.Text = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntTypography.Text, __assign({}, props));
};
Typography.Paragraph = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntTypography.Paragraph, __assign({}, props));
};
Typography.Title = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntTypography.Title, __assign({}, props));
};
Typography.Link = function (_a) {
    var props = __rest(_a, []);
    return _jsx(AntTypography.Link, __assign({}, props));
};
export default Typography;
